export const CHANGE_MAPSCALE_SCALE = 'CHANGE_MAPSCALE_SCALE';
export const TOGGLE_OPTIONAL_MAPSCALE = 'TOGGLE_OPTIONAL_MAPSCALE';
//# sourceMappingURL=constants.js.map